import { Component, OnInit,HostListener, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BnFileUploaderMiniComponent } from "@bndes/bndes-ux4/bn-file-uploader";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Tranche } from 'src/app/model/tranche.model';
import { LimitesFundo } from 'src/app/model/limite-agente-financeiro.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { LimiteService } from 'src/app/shared/services/limite.service';
import { LimiteAportado } from 'src/app/model/limite-aportado.model';
import { LimiteAporteService } from 'src/app/shared/services/limite-aporte.service';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ExportService } from '../../habilitacao/export.service';
import { ModalidadeGarantia } from 'src/app/model/modalidade_garantia.model';
import { ModalidadeGarantiaService } from '../../modalidade_garantia/modalidade-garantia.service';
import { MensagemService } from '../../mensagem.service';



@Component({
    selector: 'app-limite-contratacao-pesquisa',
    templateUrl: './limite-contratacao-pesquisa.component.html',
    styleUrls: ['./limite-contratacao-pesquisa.component.scss'],
    standalone: false
})
export class LimiteContratacaoPesquisaComponent implements OnInit {

    public cnpjUsuario: string;
    public cnpjAgentePesquisa: string;
    public agenteFinanceiro: AgenteFinanceiro;
    public agentesFinanceiros: AgenteFinanceiro[] = [];
    public podeEscolherAgente: boolean;
    public refresh: number = 0;
    public limpar: number = 0;
    public modalidade: ModalidadeGarantia;

    public agenteFinanceiroPesquisa: AgenteFinanceiro;

    public limiteAportado: LimiteAportado;
    public dataLimitePesquisa: string;
    podeImportarArquivoLegado: boolean = false;

    @ViewChild('botoesAporte') botoesPersonalizados: TemplateRef<any>;
    @ViewChild('bodyAporte') msgPersonalizada: TemplateRef<any>;

    @ViewChild('uploaderArquivoSistemaLegadoAporte')
    uploaderArquivoSistemaLegadoAporte: BnFileUploaderMiniComponent;

    constructor(private permissaoService: PermissaoService,
        private limiteAporteService: LimiteAporteService,
        private bnUsuarioService: BnUsuarioService,
        private activatedRoute: ActivatedRoute,
        private bnLoadingService:BnLoadingService,
        private exportService: ExportService,
        private modalService: BnModalMessageService,
        private modalidadeGarantiaService: ModalidadeGarantiaService,
        private mensagemService: MensagemService,) {
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
      this.buscar()
    }

    public ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {

            this.modalidadeGarantiaService.buscarModalidade().subscribe((modalidade: any) => {
                this.modalidade = modalidade;
                console.log("MODALIDADE: " + this.modalidade.textoObservacaoLimiteTotal);
            });

            this.dataLimitePesquisa = moment().format('YYYY-MM-DD HH:mm:ss'); 

            this.podeImportarArquivoLegado = resp && resp[ROLE_GESTOR_ENVIO];

            this.podeEscolherAgente = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);

            this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver

            if (this.podeEscolherAgente) {
                this.cnpjAgentePesquisa = undefined;
                this.atribuiAgenteFinanceiro();
                this.buscar();
            } else {
                this.bnUsuarioService.usuario$.subscribe(usuario => {
                    if (usuario) {
                        this.cnpjUsuario = usuario.cnpj;
                        this.cnpjAgentePesquisa = usuario.cnpj;

                        this.atribuiAgenteFinanceiro();
                        this.buscar();
                    }
                });
            }
        });
     }

    atribuiAgenteFinanceiro() {
        if (!this.cnpjAgentePesquisa) {
            this.agenteFinanceiro = new AgenteFinanceiro();
            this.agenteFinanceiro.id = null;
        }
        else {
            for (let agente of this.agentesFinanceiros) { 
                if (agente.cnpj == this.cnpjAgentePesquisa) {
                    this.agenteFinanceiro = agente;
                }
            }
        }
    }

    async atualizarLimiteFundo() {
        const limiteAportado = await this.limiteAporteService.getLimiteGlobal().toPromise();
        this.limiteAportado = limiteAportado;
        this.dataLimitePesquisa = moment().format('YYYY-MM-DD HH:mm:ss');
                  

    }
    
    buscar() {
        if (this.podeEscolherAgente) {
            this.atualizarLimiteFundo();
        }
        
        this.agenteFinanceiroPesquisa = this.agenteFinanceiro;
        this.refresh++;
    }

    exportarLista() {
        this.bnLoadingService.bloqueiaTela();
        this.limiteAporteService.getLimites(this.agenteFinanceiroPesquisa.id).subscribe((response) => {
            this.exportService.exportarListaLimiteContratacao(response);
        })
        this.bnLoadingService.liberaTela();
    }

    limparPesquisa() {
        this.cnpjAgentePesquisa = undefined;
        this.agenteFinanceiro = undefined;

        this.limpar++;
    }

    close() {
        this.modalService.close();
    }

    abrirModalAporteLegado() {

        this.modalService.abrir(
            'Importar arquivo do sistema legado',
            'Importar arquivo do sistema legado',
            'lg',
            this.msgPersonalizada,
            this.botoesPersonalizados
        );

    }

   

    async importarArquivoLegadoAporte() {

        if (this.uploaderArquivoSistemaLegadoAporte.listaPendente.length < 1) {
            this.mensagemService.adicionarMensagemAviso('O arquivo a ser importado não foi adicionado.');
            return;
        }

        try {
            this.bnLoadingService.bloqueiaTela();
            await this.limiteAporteService.importarArquivoLegadoAporte(this.uploaderArquivoSistemaLegadoAporte);
            this.close();
            this.buscar();
            await this.limiteAporteService.getLimites(this.agenteFinanceiroPesquisa.id).toPromise();
            this.bnLoadingService.liberaTela();
            this.mensagemService.adicionarMensagemSucesso('Importação de arquivo legado realizada com sucesso.');
        
 
            

        } catch (error) {
            this.mensagemService.adicionarMensagemErro('Erro ao importar arquivo legado. Favor, verificar arquivo.');
            this.bnLoadingService.liberaTela();
            return;
        }

    }

}
